import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=37f174f0&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f174f0')) {
      api.createRecord('37f174f0', component.options)
    } else {
      api.reload('37f174f0', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=37f174f0&", function () {
      api.rerender('37f174f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21vwooRuNf4EY/JS/offershelp.vue"
export default component.exports